import { render } from "./PullDownRefresh.vue?vue&type=template&id=6ff0dcb6&scoped=true"
import script from "./PullDownRefresh.vue?vue&type=script&lang=js"
export * from "./PullDownRefresh.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff0dcb6"]])

export default __exports__